import menuDataReducer, { MenuDataState, fetchActions } from "./active";

export default menuDataReducer;

export { fetchActions };

export interface State {
    menuData: MenuDataState;
}
